import Store from "../store/Store";
import { api } from "./customers";

export interface UserProfile {
  id: number;
  fullName: string;
  email: string;
  phoneNumber: number;
  profileImage: any;
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

type UserProfileResponse = UserProfile[];

export const UserManagementApi = api.injectEndpoints({
  endpoints: (build) => ({
    changePassword: build.mutation<UserProfileResponse, Partial<any>>({
      query: (body: any) => ({
        url: `change_password`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: UserProfileResponse }, meta, arg) =>
        response.data,
      invalidatesTags: [{ type: "UserManagement", id: "LIST" }],
    }),
    getUserProfileDetails: build.query<UserProfileResponse, void>({
      query: () => `user_profiles_details`,
      transformResponse: (response: { data: UserProfileResponse }, meta, arg) =>
        response.data,
    }),
    getTemplateImage: build.query<UserProfileResponse, void>({
      query: () => `landing_image`,
      transformResponse: (response: { data: UserProfileResponse }, meta, arg) =>
        response.data,
    }),
    getHospitalProfileDetails: build.query<UserProfileResponse, any>({
      query: (id) => `hospital_profiles`,
      providesTags: ["Reports"],
      transformResponse: (response: { data: UserProfileResponse }, meta, arg) =>
        response.data,
    }),
    updateUserProfile: build.mutation<void, Partial<any>>({
      query: (patch) => ({
        url: `user_profiles_update`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: [{ type: "UserManagement", id: "LIST" }],
    }),
    updateTemplateImage: build.mutation<void, Partial<any>>({
      query: (patch) => ({
        url: `landing_image/${Store.getState().auth.hospital_code}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: [{ type: "UserManagement", id: "LIST" }],
    }),
    userChangePassword: build.mutation<UserProfileResponse, Partial<any>>({
      query: (body: any) => ({
        url: `reset_password`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: UserProfileResponse }, meta, arg) =>
        response.data,
    }),
  }),
});

export const {
  useGetUserProfileDetailsQuery,
  useChangePasswordMutation,
  useUpdateUserProfileMutation,
  useGetHospitalProfileDetailsQuery,
  useGetTemplateImageQuery,
  useUpdateTemplateImageMutation,
  useUserChangePasswordMutation
} = UserManagementApi;
